module.exports = __webpack_public_path__ + "images_/biz-micro-services-ui/project/middlePlatform/asset/silver_medal.png";


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/project/middlePlatform/asset/silver_medal.png
// module id = 2032
// module chunks = 367